module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Switch 开关")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "fg-gray no-margin-bottom"
  }, [_vm._v("Modern 现代风格")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch\">\n  <input type=\"checkbox\">\n  <span class=\"check\"></span>\n</label>\n\n<label class=\"switch\">\n  <input type=\"checkbox\" checked>\n  <span class=\"check\"></span>\n</label>\n")])]), _vm._v(" "), _c('p', [_vm._v("禁用状态")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch\">\n  <input type=\"checkbox\" disabled>\n  <span class=\"check\"></span>\n</label>")])])]), _vm._v(" "), _c('section', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "fg-gray"
  }, [_vm._v("Original 传统风格")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch-original\">\n  <input type=\"checkbox\">\n  <span class=\"check\"></span>\n</label>\n\n<label class=\"switch-original\">\n  <input type=\"checkbox\" checked>\n  <span class=\"check\"></span>\n</label>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("禁用状态")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch-original\">\n  <input type=\"checkbox\" disabled>\n  <span class=\"check\"></span>\n</label>")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6c44bf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/switch.vue
// module id = 410
// module chunks = 1